// Lib
import React from 'react';

import PropTypes from 'prop-types';

// Utils
import { prop } from '../../../../common/utils/immutableHelper';
import { hasSeen } from '../../../../common/users/userEducationUtil';

// Components
import BrowserUnsupportedFullScreenWarning from './warningModals/BrowserUnsupportedFullScreenWarning';
import BrowserCookieFullScreenWarning from './warningModals/BrowserCookieFullScreenWarning';
import BrowserMobileDemoBoardFullScreenWarning from './warningModals/BrowserMobileDemoBoardFullScreenWarning';
import BrowserMobileFullScreenSignupSuccess from './warningModals/BrowserMobileFullScreenSignupSuccess';

// Constants
import { LOCAL_STORAGE_FEATURE_NAME } from './browserDetectionService';
import { ONBOARDING_EDUCATION_CODES } from '../../../../common/users/userEducationConstants';
import { getIsSwiftHybrid } from '../../../hybridApp/hybridAppUtils';

const BrowserWarning = (props) => {
    const {
        supportedBrowser,
        features,
        acknowledgement,
        showingDetatchedHeader,
        isUsingMobileView,
        isGuest,
        currentUser,
    } = props;

    // if user does not have local storage enabled
    if (!features.isSupported && features.errors.indexOf(LOCAL_STORAGE_FEATURE_NAME) !== -1 && !acknowledgement) {
        return <BrowserCookieFullScreenWarning {...props} />;
    }

    // if user is not using a supported browser, or their browser doesn't support required features
    if ((!supportedBrowser || !features.isSupported) && !acknowledgement) {
        return <BrowserUnsupportedFullScreenWarning {...props} />;
    }

    // if user is viewing a demo board on mobile
    if (isUsingMobileView && showingDetatchedHeader && isGuest && !acknowledgement) {
        return <BrowserMobileDemoBoardFullScreenWarning {...props} />;
    }

    // if user has freshly signed up on mobile, force them to view app on desktop
    // After they see the desktop education allow them to use the app on mobile
    // Except when the app is run for mobile hybrid.
    if (
        !getIsSwiftHybrid() &&
        isUsingMobileView &&
        !isGuest &&
        currentUser &&
        prop('fetched', currentUser) &&
        !hasSeen(currentUser.get('education'), ONBOARDING_EDUCATION_CODES.DESKTOP_ONBOARDING)
    ) {
        return <BrowserMobileFullScreenSignupSuccess {...props} />;
    }

    return null;
};

BrowserWarning.propTypes = {
    supportedBrowser: PropTypes.bool,
    features: PropTypes.object,
    acknowledgement: PropTypes.bool,
    showingDetatchedHeader: PropTypes.bool,
    isUsingMobileView: PropTypes.bool,
    isMobile: PropTypes.bool,
    isGuest: PropTypes.bool,
    isIOS: PropTypes.bool,
    acknowledgeUnsupportedBrowser: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
};

export default BrowserWarning;
